import React, {Component} from 'react';
import {connect} from 'react-redux';
import {
    withStyles,
    Tab,
    Tabs,
    Icon,
    Typography
} from "@material-ui/core";
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReduxMission from "../../../../store/actionreducers/mission";
import ReduxCallHelper from "../../../../store/actionreducers/callHelper";
import MissionInfoTab from "../../../../components/MissionInfoTab";
import PeopleTab from './tabs/PeopleTab';
import ProgressAndActionTab from './tabs/ProgressAndActionTab';
import ArchivesTab from './tabs/ArchivesTab';
import {FuseAnimate, FusePageCarded} from '@fuse';
import {Link, withRouter} from 'react-router-dom';
import {bindActionCreators} from 'redux';
import {UecareAlertDialog} from "../../../../components";
import NoticeTab from "./tabs/NoticeTab";
import ModifyReservedTimeTab from "./tabs/ModifyReservedTimeTab";

class MissionsApp extends Component {

    state = {
        tabValue: 0,
    };

    handleChangeTab = (event, tabValue) => {
        this.setState({tabValue});
    };

    async componentDidMount() {
        try {
            const missionId = this.props.match.params.id;
            const mission = await this.props.getMission(missionId);
            await this.props.setMission(mission);
            await this.props.getMedicals();
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    }

    isMissionNeedToPair(mission) {

        const needToPairStatusList = [
            {id: 1, name: '未執行', label: 'todo'},
            {id: 2, name: '委託中', label: 'finding'}, // 委託中
            {id: 4, name: '重新配對中', label: 'rematching'}, // 重新配對中
            {id: 11, name: '等待中', label: 'waiting'},
        ];

        return needToPairStatusList.map(status => status.label).includes(mission.status.label);
    }

    isMissionFinished(mission) {
        const statusLabel = mission.status && mission.status.label;
        return statusLabel === 'done';
    }

    render() {
        const {mission} = this.props;
        const {tabValue} = this.state;

        return (
            <FusePageCarded
                innerScroll
                header={
                    <div className="flex flex-1 p-24 items-center justify-between">

                        <div className="flex flex-col items-start max-w-full">

                            <FuseAnimate animation="transition.slideRightIn" delay={300}>
                                <Typography className="normal-case flex items-center sm:mb-12" component={Link}
                                            role="button" to="/apps/mission">
                                    <Icon className="mr-4 text-20">arrow_back</Icon>
                                    任務列表
                                </Typography>
                            </FuseAnimate>

                            <div className="flex items-center max-w-full">
                                <FuseAnimate animation="transition.expandIn" delay={300}>
                                    <img className="w-32 sm:w-48 mr-8 sm:mr-16 rounded"
                                         alt=''
                                         src="assets/images/ecommerce/product-image-placeholder.png"/>
                                </FuseAnimate>
                                <div className="flex flex-col min-w-0">
                                    <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                        <div>
                                            <Typography className="text-16 sm:text-20">
                                                {mission.no ? mission.no : 'No Mission Number'}
                                            </Typography>
                                            <Typography className="text-6 truncate">
                                                問題描述 : {mission.description ? mission.description : ''}
                                            </Typography>
                                        </div>
                                    </FuseAnimate>
                                </div>
                            </div>
                        </div>
                    </div>
                }
                contentToolbar={
                    <Tabs
                        value={tabValue}
                        onChange={this.handleChangeTab}
                        indicatorColor="secondary"
                        textColor="secondary"
                        scrollable
                        scrollButtons="auto"
                        classes={{root: "w-full h-42"}}
                        className='bg-grey-light'>
                        <Tab className="h-42 normal-case font-extrabold font" label="基本資訊"/>
                        <Tab className="h-42 normal-case font-extrabold"
                             label="參與人員"/>
                        <Tab className="h-42 normal-case font-extrabold"
                             label="目前進度&任務操作"/>
                        <Tab className="h-42 normal-case font-extrabold"
                            label="諮詢錄影"/>
                        <Tab className="h-42 normal-case font-extrabold"
                             label="新增備註"/>
                        {(mission.reservation_mission) &&
                            <Tab className="h-42 normal-case font-extrabold"
                                 label="更改預約時間"/>
                        }
                        {this.isMissionNeedToPair(mission) && <Tab className="h-42 normal-case font-extrabold" label="發送或委派醫生"/>}
                    </Tabs>
                }
                content={
                    <div>
                        <div className="p-16 sm:p-24 max-w-2xl">
                            {tabValue === 0 && (<MissionInfoTab/>)}
                            {tabValue === 1 && (<PeopleTab/>)}
                            {tabValue === 2 && (<ProgressAndActionTab/>)}
                            {tabValue === 3 && (<ArchivesTab isFinished={this.isMissionFinished(mission)}/>)}
                            {tabValue === 4 && (<NoticeTab />)}
                            {/* {tabValue === 5 && (<MedicalListTab/>)} */}
                            {Boolean(tabValue === 5 && mission.reservation_mission) && <ModifyReservedTimeTab />}
                        </div>
                        <UecareAlertDialog/>
                    </div>
                }
            />
        )
    };
}

const styles = theme => ({});

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getMission: ReduxMission.ActionCreator.getMission,
        setMission: ReduxMission.ActionCreator.setMission,
        getMissions: ReduxMission.ActionCreator.getMissions,
        getMedicals: ReduxCallHelper.ActionCreator.getMedicals,
        openDataDialog: ReduxGlobal.ActionCreator.openDataDialog,
    }, dispatch);
}

function mapStateToProps({mission}) {
    return {tempMission: mission.temp, mission};
}

export default withStyles(styles, {withTheme: true})(withRouter(connect(mapStateToProps, mapDispatchToProps)(MissionsApp)));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/mission/MissionApp.js